import { useEffect, useState } from "react";
import { getTopCustomers } from "api";
import CustomerModal from "./CustomerModal";

function rowTier(i) {
  if (i === 0) return "tc-row tc-row-first";
  if (i <= 2) return "tc-row tc-row-second";
  return "tc-row";
}

function TopCustomers() {
  const [customers, setCustomers] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getTopCustomers().then(setCustomers).catch(() => {});
  }, []);

  return (
    <>
      <div className="faux-dash-item" style={{ padding: 0, overflow: "hidden" }}>
        <div style={{ padding: "20px 24px 12px" }}>
          <h2>Top Customers</h2>
        </div>
        {customers.length === 0 ? (
          <div style={{ padding: "16px 24px", fontSize: "13px", color: "var(--ad-text-muted)" }}>
            No data yet.
          </div>
        ) : (
          <div>
            {customers.map((c, i) => (
              <div
                key={c.phone}
                className={rowTier(i)}
                onClick={() => setSelected(c)}
              >
                <span className="tc-rank">#{i + 1}</span>
                <span className="tc-name">{c.name || c.phone}</span>
                <span className="tc-count">{c.count}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {selected && (
        <CustomerModal
          phone={selected.phone}
          name={selected.name}
          onClose={() => setSelected(null)}
        />
      )}
    </>
  );
}

export default TopCustomers;
